import { NavLink } from 'react-router-dom';
import { cn, LocalStorageUtils, RoutePaths } from '@shared/utils';
import InstagramIcon from '@assets/images/instagram.svg';

const year = new Date().getFullYear();

export const Footer = () => {
  const stuffData = LocalStorageUtils.getStuff();

  return (
    <footer className='mt-auto flex h-[205px] items-start justify-between bg-white p-8 max-md:relative max-md:h-auto max-md:w-full max-md:flex-col-reverse max-md:p-0 max-md:pb-[52px]'>
      <div
        className={cn(
          'flex w-[504px] flex-nowrap justify-between max-md:w-full max-md:flex-col max-md:py-8 max-md:text-center',
          !stuffData?.token && 'block justify-start',
        )}
      >
        <div
          className={cn('mb-5 shrink-0 grow basis-auto flex-wrap pl-9 max-md:mb-8 max-md:hidden max-md:p-0', stuffData?.token ? 'grow' : 'grow-0')}
        >
          <NavLink
            to={RoutePaths.contact.onNavigate()}
            className='block h-[20px] w-full font-[ProximaNova-Medium] text-sm font-medium text-[#4c4c4c] max-md:mb-3 max-md:text-[22px]'
          >
            Contact
          </NavLink>
        </div>

        <div className='shrink-0 grow-0 basis-[33%] flex-wrap pl-9 max-md:mb-8 max-md:p-0'>
          <p className='block h-[20px] w-full font-[ProximaNova-Medium] text-sm font-medium text-[#4c4c4c] max-md:mb-3 max-md:text-[22px]'>Website</p>
          <NavLink
            to={RoutePaths.privacy.onNavigate()}
            className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:mb-2 max-md:text-base'
          >
            Privacy Policy
          </NavLink>
          <NavLink
            to={RoutePaths.cook.onNavigate()}
            className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:mb-2 max-md:text-base'
          >
            Cookies Policy
          </NavLink>
          <NavLink
            to={RoutePaths.conditions.onNavigate()}
            className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:m-0 max-md:text-base'
          >
            Website Terms &amp; Conditions
          </NavLink>
        </div>
        {stuffData?.token && (
          <div className='shrink-0 grow-0 basis-[33%] flex-wrap pl-9 max-md:pl-0'>
            <p className='block h-[20px] w-full font-[ProximaNova-Medium] text-sm font-medium text-[#4c4c4c] max-md:mb-3 max-md:text-[22px]'>
              Resource Centre
            </p>
            <NavLink
              to={RoutePaths.conditionsCard.onNavigate()}
              className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:mb-2 max-md:text-base'
            >
              Membership Terms &amp; Conditions
            </NavLink>
            <NavLink
              to={RoutePaths.form.onNavigate()}
              className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:mb-2 max-md:text-base'
            >
              Eligibility Form
            </NavLink>
            <NavLink
              to={RoutePaths.tariff.onNavigate()}
              className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:m-0 max-md:text-base'
            >
              Schedule of Fees and Charges
            </NavLink>
            {/* <NavLink to={RoutePaths.faq.onNavigate()} className='block h-[20px] w-full cursor-pointer text-xs font-medium whitespace-nowrap text-[#4c4c4c] hover:underline max-md:m-0 max-md:text-base' >
                  FAQs
                </NavLink> */}
          </div>
        )}
      </div>
      <div className='flex h-full flex-col items-end justify-between max-md:w-full'>
        <div className='flex max-md:w-full max-md:flex-row-reverse max-md:items-center max-md:justify-between max-md:border-b max-md:border-b-[#4c4c4c1a] max-md:p-4'>
          <div className='flex items-center'>
            <a href='https://www.instagram.com/insignia.worldwide/' target='_blank' rel='noreferrer'>
              <InstagramIcon className='mr-5.5' />
            </a>
            <a href='https://www.linkedin.com/company/insignia-lifestyle-management/' target='_blank' rel='noreferrer'>
              <img className='mr-7.5 w-[24px] max-md:m-0' src='../../assets/images/linked-in-icon.svg' alt='linkedin' />
            </a>
          </div>
          <a href='https://insignia.com' target='_blank' rel='noreferrer'>
            <img src='../../assets/images/INSIGNIA_TOTAL_LOGO_FINAL.svg' alt='insignia' />
          </a>
        </div>
        {/* <a href={'https://apps.apple.com/us/app/master-key/id1227460308'}>
          <img src='../../assets/images/app-store-load-banner.svg' alt='' className='appStore' />
        </a> */}
        <div className='self-end text-xs font-light text-[#525252] max-md:absolute max-md:bottom-0 max-md:left-0 max-md:h-[52px] max-md:w-full max-md:border-t max-md:border-[#4c4c4c1a] max-md:p-4 max-md:text-center'>
          ©Copyright {year} Insignia Group
        </div>
      </div>
    </footer>
  );
};
